import * as React from 'react';
import { useMemo } from 'react';

import { Stack, Text } from '@mantine/core';
import { StaffAvailability } from 'types';
import { DayOfWeekEnum } from 'types/enums';

import WeekDayStaffAvailability from './WeekDayStaffAvailability';

const WeekDayStaffAvailabilityList = ({
  dayOfWeek,
  data,
  isEditable,
}: {
  dayOfWeek: DayOfWeekEnum;
  data: StaffAvailability[];
  isEditable: boolean;
}): JSX.Element => {
  const filteredListByDayOfWeek = useMemo(() => {
    return data.filter(sa => sa.dayOfWeek === dayOfWeek);
  }, [data, dayOfWeek]);

  return (
    <Stack>
      {!filteredListByDayOfWeek.length && (
        <Text color='gray.6' fs='italic' size='lg' weight={600} mr='md'>
          Currently Unavailable
        </Text>
      )}

      {filteredListByDayOfWeek.map(sa => (
        <WeekDayStaffAvailability
          key={sa.staffAvailabilityId}
          staffAvailability={sa}
          isEditable={isEditable}
        />
      ))}
    </Stack>
  );
};

export default WeekDayStaffAvailabilityList;
